export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  mounted() {
    window.addEventListener('click', this.onClick);
  },
  beforeDestroy() {
    //   解绑监听click
    window.removeEventListener('click', this.onClick);
  },
  methods: {
    onClick(e) {
      if (!this.$el.contains(e.target)) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    }
  }
};